import React from 'react';
import PropTypes from 'prop-types';

import { InputWrapper } from './css';
import Note from '../../note';

const FieldTextNote = ({ data }) => {
  const { note, isWarningMessage, isShowNoteBackground, isItalicNote} = data;
  return (
    <InputWrapper>
      {note && note.content && <Note type="richText" data={note} isItalicNote={isItalicNote} isWarningMessage={isWarningMessage} isShowNoteBackground={isShowNoteBackground} />}
    </InputWrapper>
  );
};

FieldTextNote.propTypes = {
  data: PropTypes.shape({
    note: PropTypes.shape({
      content: PropTypes.arrayOf(PropTypes.object)
    }).isRequired
  }).isRequired
};

export default FieldTextNote;
